export default __webpack_public_path__ + "static/media/212711.6d9648ab.jpg";